import CustomFilterSelect from "./CustomFilterSelect";

const FilterRemainingTerm = (props: any) => {
  const FilterData = [
    { id: "<12 Months", name: "<12 Months" },
    { id: "12-24 Months", name: "12-24 Months" },
    { id: "24-36 Months", name: "24-36 Months" },
    { id: "36-48 Months", name: "36-48 Months" },
    { id: "48-60 Months", name: "48-60 Months" },
    { id: ">60 Months", name: ">60 Months" },
  ];
  // console.log("productList ===>", productList);
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="remainingterm"
      label="Remaining Term"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterRemainingTerm;
